<template>
  <div class="relative">
    <div :class="{ 'opacity-60 pointer-events-none': loading }">
      <div class="border-t-[#EEE] border-t border-solid sm:hidden">
        <div
          class="schedule_time"
          v-for="rowIndex in visibleRows"
          :key="rowIndex"
          :style="{ gridTemplateColumns: `repeat(${gridColumns}, 1fr)` }"
        >
          <button
            v-for="(column, columnIndex) in columnsToRender"
            :key="columnIndex"
            type="button"
            :disabled="loading || bookingInProgress || !isSelectableTime(resolveTime(column, rowIndex - 1), resolveDate(column))"
            @click="emitSelect(column, rowIndex - 1)"
          >
            <InlineSpinner
              v-if="isButtonLoading(resolveDate(column), resolveTime(column, rowIndex - 1))"
              size="18"
            />
            <span v-else>{{ resolveTime(column, rowIndex - 1) }}</span>
          </button>
        </div>
      </div>
      <div class="border-t-[#EEE] border-t border-solid hidden sm:block">
        <div
          class="schedule_time"
          v-for="rowIndex in visibleRows"
          :key="rowIndex"
          :style="{ gridTemplateColumns: `repeat(${gridColumns}, 1fr)` }"
        >
          <button
            v-for="(column, columnIndex) in columnsToRender"
            :key="columnIndex"
            type="button"
            :disabled="loading || bookingInProgress || !isSelectableTime(resolveTime(column, rowIndex - 1), resolveDate(column))"
            @click="emitSelect(column, rowIndex - 1)"
          >
            <InlineSpinner
              v-if="isButtonLoading(resolveDate(column), resolveTime(column, rowIndex - 1))"
              size="18"
            />
            <span v-else>{{ resolveTime(column, rowIndex - 1) }}</span>
          </button>
        </div>
      </div>
      <div class="pt-[1rem] text-center" v-if="!loading && canLoadMore">
        <a
          href="javascript:void(0)"
          class="text-black font-medium text-center underline transition-[0.3s] duration-[ease] hover:text-[#111827] hover:bg-[#f2f3f5] hover:border hover:border-[#d1d5db] hover:no-underline px-3 py-1 rounded-[1.2rem] inline-block"
          @click="$emit('load-more')"
        >
          {{ $t('Load more schedules') }}
        </a>
      </div>
      <div class="pt-[1.2rem] text-center" v-else-if="!loading && canShowLess">
        <a
          href="javascript:void(0)"
          class="text-black font-medium text-center underline transition-[0.3s] duration-[ease] hover:text-[#111827] hover:bg-[#f2f3f5] hover:border hover:border-[#d1d5db] hover:no-underline px-3 py-1 rounded-[1.2rem] inline-block"
          @click="$emit('show-less')"
        >
          {{ $t('Show fewer schedules') }}
        </a>
      </div>
    </div>
    <div
      v-if="loading"
      class="absolute inset-0 flex items-center justify-center bg-white/70 rounded-[2rem]"
    >
      <InlineSpinner size="26" />
    </div>
  </div>
</template>

<script>
import InlineSpinner from '@/components/loader/InlineSpinner.vue';

export default {
  name: 'DoctorScheduleTimeGrid',
  components: {
    InlineSpinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    visibleRows: {
      type: Number,
      default: 0,
    },
    columnCount: {
      type: Number,
      default: 0,
    },
    bookingInProgress: {
      type: Boolean,
      default: false,
    },
    canLoadMore: {
      type: Boolean,
      default: false,
    },
    canShowLess: {
      type: Boolean,
      default: false,
    },
    isSelectableTime: {
      type: Function,
      required: true,
    },
    isButtonLoading: {
      type: Function,
      required: true,
    },
  },
  computed: {
    gridColumns() {
      return Math.max(this.columnCount, 1);
    },
    columnsToRender() {
      if (!Array.isArray(this.columns)) {
        return [];
      }
      const count = Math.max(this.columnCount, 0);
      return this.columns.slice(0, count);
    },
  },
  methods: {
    resolveDate(column) {
      if (!column || typeof column !== 'object') {
        return null;
      }
      return column.date !== undefined && column.date !== null ? column.date : null;
    },
    resolveTime(column, rowIndex) {
      if (!column || typeof column !== 'object') {
        return '-';
      }
      const times = Array.isArray(column.times) ? column.times : [];
      const value = rowIndex >= 0 && rowIndex < times.length ? times[rowIndex] : undefined;
      return value !== undefined && value !== null ? value : '-';
    },
    emitSelect(column, rowIndex) {
      const date = this.resolveDate(column);
      const time = this.resolveTime(column, rowIndex);
      this.$emit('select-time', date, time);
    },
  },
};
</script>

<style scoped>
.schedule_time {
  @apply grid grid-cols-[repeat(4,1fr)] items-center justify-center gap-[0.6rem] pt-[0.6rem] px-[2.4rem] py-0;
}

.schedule_time button {
  @apply text-[#1f2937] font-medium w-full text-[1.3rem] px-0 py-[0.6rem] rounded-[0.8rem] border-[none] cursor-pointer transition-colors;
  background: #f4f5f7;
}
.schedule_time button:not(:disabled):hover {
  @apply text-white;
  background: #5b6fee;
}
.schedule_time button:disabled {
  @apply opacity-50 cursor-default;
}
</style>
